import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material'
import React from 'react'
import { EmailMessageDto } from '../../services/api/sharedTypes/Email'
import CustomTextField from '../common/CustomTextField'

interface LocalEmailType extends Omit<EmailMessageDto, 'clientIdName' | 'createdAt' | 'lastModifiedAt' | 'eventIdName'> {
    createdAt: number
    lastModifiedAt: string
    eventIdName: string
    eventId: string
    eventName: string
    clientIdName: string
    clientId: string
    clientName: string
}
interface EditEmailDialogProps {
    onSend: (id: string, subject: string, emailBody: string, updateAndSendEmailMessage?: boolean) => void
    email: LocalEmailType
    button: React.ReactNode
    /**
     * type - type of action called on button click
     * 'sendAndEdit' - send and edit email
     * 'edit' - edit email
     */
    type: 'sendAndEdit' | 'edit'
}

const EditEmailDialog: React.FC<EditEmailDialogProps> = ({ onSend, email, button, type }: EditEmailDialogProps) => {
    const [isDialogOpen, setIsDialogOpen] = React.useState(false)
    const [localEmail, setLocalEmail] = React.useState<LocalEmailType>(email)

    const handleCloseDialog = () => {
        setIsDialogOpen(false)
    }

    const handleOpenDialog = () => {
        setLocalEmail(email)
        setIsDialogOpen(true)
    }

    return (
        <div>
            <div onClick={handleOpenDialog}>{button}</div>
            <Dialog open={isDialogOpen} onClose={handleCloseDialog} maxWidth='lg' fullWidth>
                <DialogTitle textAlign='center'>{localEmail.emailRecipient}</DialogTitle>
                <DialogContent>
                    <Stack spacing={3} mt={3}>
                        <CustomTextField
                            size='small'
                            fullWidth
                            label='Předmět emailu'
                            value={localEmail.subject}
                            onChange={(e) => setLocalEmail({ ...localEmail, subject: e.target.value })}
                        />
                        <CustomTextField
                            size='small'
                            fullWidth
                            multiline
                            rows={10}
                            label='Zpráva'
                            value={localEmail.body}
                            onChange={(e) => setLocalEmail({ ...localEmail, body: e.target.value })}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseDialog}>Zavřít</Button>
                    <Button
                        onClick={() => {
                            onSend(localEmail.id, localEmail.subject ?? '', localEmail.body ?? '', type === 'sendAndEdit')
                            type === 'sendAndEdit' && handleCloseDialog()
                        }}
                        variant='contained'
                    >
                        {type === 'sendAndEdit' ? 'Odeslat' : 'Upravit'}
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

export default EditEmailDialog
